import Vue from 'vue';
import { Component, Prop, PropSync, Watch } from 'vue-property-decorator';
import EumFileUpload from 'eum-file-upload'
import api from '@mail/api'
import { invalidateUrl } from '@appbase/util'
import config from '@/modules/@appbase/util/config';

@Component({components:{EumFileUpload}})
export default class WriteAttachment extends Vue {
    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    uploadUrl: string = ''
    deleteUrl: string = ''
    files: appbase.FileInfo[] = []
    totalSize: number = 0
    bannedExtentions: string[] = []
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //
    @Prop({ type: Object }) value!: mail.WriteEmailData

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    loadFiles(id: string | null, method: mail.EmailSendMethods | null) {
      if (!id) {
        id = this.value.id as string
      }
      if (!method) {
        method = this.value.method
      }
      Promise.all([
        api.mail.getAttachments(id),
        api.mail.getFiles(this.value?.code || ''),
      ]).then((results) => {
        const tcfiles = results[0]
        const emailfiles = results[1]
        var files: any[] = []
        if (tcfiles) {
          files = files.concat(tcfiles)
        }
        if (emailfiles) {
          files = files.concat(emailfiles)
        }
        this.files = files.map((file) => ({
          ...file,
          custom: true,
          percent: 100,
          status: 'succeed',
          uniqueIdentifier: file.id,
          type: 'Database',
        })) as any
      })
    }

    deleteFiles(files: appbase.FileInfo[]): Promise<boolean> {
      console.log('deletefiles', files)
      const itemId = this.value?.id || ''
  
      return api.mail
        .deleteAttachments(
          itemId,
          files.map((f) => f.id)
        )
        .then(() => true)
        .catch((err) => {
          console.error(err)
          return false
        })
    }

    @Watch('value.id')
  onValueChanged(newValue: string) {
    this.loadFiles(newValue, this.value.method)
  }

  @Watch('value.method')
  onMethodChanged(newValue: mail.EmailSendMethods) {
    this.loadFiles(this.value.id as string, newValue)
  }

  @Watch('totalSize')
  onTotalSizeChanged(value: number) {
    this.$emit('totalsize', value)
  }

  @Watch('value.stateEmpty')
  onStateEmptyChanged(newval: number) {
    if (newval > 0) {
      this.files = []
    }
  }
    
    
    @Watch('files')
    onFilesChanged(files: any[]) {
      var size = files.map<number>((f) => f.size).reduce((a, b) => a + b, 0)
      // const { transitionSize } = this.bigfileConfig;
      // if ((this.totalSize = size) > transitionSize) {
      //   const visibles: mail.state.MailWriteVisibles = Object.create(null)
      //   visibles.bigfile = true
      //   this.changeVisibles(visibles)
      //   this.value.transitionDisabled = true
      // } else {
        this.value.transitionDisabled = false
      // }
    }

    attach(){
      (this.$refs.browseButton as any).click();
    }

    created(){
      this.uploadUrl = invalidateUrl('/cm/file/store/flow')
      this.deleteUrl = invalidateUrl('/cm/file/store/deleteFile')
      this.bannedExtentions = config.get('RejectUploadFileExts')?.split(';')
    }

    mounted(){
      this.loadFiles(this.value.id as string, this.value.method)
    }
   
}
